import React from 'react';
import getRandomKey from '../key-generator';
import {
  ActionInvokeSceneType,
  ActionPlaySoundType,
  ActionSwitchFrameLedType,
  ActionSwitchType,
  DeviceStateValues
} from './devices.types';
import {
  Relay,
  PowerPowerPower,
  Smoke,
  DoubleSwitch,
  Power,
  PowerPower,
  SwitchPower,
  PowerSwitch,
  DoubleSwitchPower,
  PowerDoubleSwitch,
  DoubleSwitchSwitch,
  WifiPowerPower,
  RJPower,
  RJPowerPower,
  Buzzer,
  Unknown,
  Temperature,
  Switch,
  SwitchSwitchSwitch,
  DoubleSwitchBuzzerPower,
  DoubleSwitchDoubleSwitchPower,
  SwitchPowerBuzzer,
  DoubleSwitchDoubleSwitchPowerBuzzer,
  SmokeWifiRelay,
  SmokeWifi,
  SwitchSwitch,
  SmartPowerIcon,
  RelayIcon,
  PulseSwitchIcon,
  SmokeDetectorIcon,
  BuzzerIcon,
  WifiIcon,
  EthernetIcon,
  FrameButtonIcon,
  FrameLedIcon
} from '../../components/icons';
import { SvgProps } from '../../components/Svg/Svg.types';

export enum PressProfiles {
  singlePress = 'EventShortPress',
  doublePress = 'EventDoublePress'
}
export const buzzerMelodies = {
  0: {
    url: 'sounds/buzzerMelodies/0.wav',
    name: 'Melody 1'
  },
  1: {
    url: 'sounds/buzzerMelodies/1.wav',
    name: 'Melody 2'
  }
};

export const ledHsColor = {
  white: {
    Color: {
      hue: 0,
      saturation: 0
    },
    Brightness: 0
  }
};
export const scenesLedColors = {
  white: {
    hue: 0,
    saturation: 0
  },
  purple: {
    hue: 252,
    saturation: 79
  },
  red: {
    hue: 15,
    saturation: 68
  },
  yellow: {
    hue: 46,
    saturation: 54
  },
  green: {
    hue: 122,
    saturation: 51
  }
};

export const devicesConnectionsLedColors = {
  default: null,
  white: {
    hue: 0,
    saturation: 0
  },
  yellow: {
    hue: 60,
    saturation: 92
  },
  orange: {
    hue: 28,
    saturation: 97
  },
  purple: {
    hue: 299,
    saturation: 92
  },
  violet: {
    hue: 271,
    saturation: 96
  },
  blue: {
    hue: 241,
    saturation: 94
  },
  aquamarine: {
    hue: 180,
    saturation: 95
  },
  green: {
    hue: 136,
    saturation: 32
  }
};

export const deviceActions = [
  {
    key: 'ActionSwitch',
    value: (value = DeviceStateValues.ON): ActionSwitchType => ({
      SwitchAction: value
    }),
    trigger: false
  },
  {
    key: 'ActionPlaySound',
    value: (value = 0): ActionPlaySoundType => ({
      SoundNumber: value
    }),
    trigger: true
  },
  {
    key: 'ActionSwitchFrameLed',
    value: (
      value = DeviceStateValues.ON,
      Color = ledHsColor.white
    ): ActionSwitchFrameLedType => ({
      SwitchFrameLedAction: value,
      ...Color
    }),
    trigger: false
  },
  {
    key: 'ActionInvokeScene',
    value: (value = ''): ActionInvokeSceneType => ({
      SceneId: value
    }),
    trigger: false
  }
];
export const devices = {
  powerSocket: {
    symbol: '1',
    name: 'Power Socket',
    icon: 'devices-icons/smart-power',
    alwaysOnSupport: true
  },
  relayBin: {
    symbol: '4',
    name: 'Relay',
    icon: 'devices-icons/relay',
    alwaysOnSupport: false
  },
  pulseSwitch: {
    symbol: 'S',
    name: 'Pulse Switch',
    icon: 'devices-icons/pulse-switch',
    alwaysOnSupport: false
  },
  smokeDetector: {
    symbol: 'D',
    name: 'Smoke Detector',
    icon: 'devices-icons/smoke-detector',
    alwaysOnSupport: false
  },
  buzzer: {
    symbol: 'B',
    name: 'Buzzer',
    icon: 'devices-icons/buzzer',
    alwaysOnSupport: false
  },
  wifi: {
    symbol: 'W',
    name: 'Wifi',
    icon: 'devices-icons/wifi',
    alwaysOnSupport: false
  },
  ethernet: {
    symbol: 'R',
    name: 'Ethernet',
    icon: 'devices-icons/ethernet',
    alwaysOnSupport: false
  },
  frameButton: {
    symbol: 'Z',
    name: 'Frame Button',
    icon: 'devices-icons/frame-button',
    alwaysOnSupport: false
  },
  frameLed: {
    symbol: 'L',
    name: 'Frame Led',
    icon: 'devices-icons/frame-led',
    alwaysOnSupport: false
  },
  doubleSwitch: {
    symbol: 'T',
    name: 'Double Switch',
    icon: '',
    alwaysOnSupport: false
  }
};
export const roundDevicesSymbols = [devices.smokeDetector.symbol];

export const devicesMap = {
  '1': SmartPowerIcon,
  '4': RelayIcon,
  S: PulseSwitchIcon,
  D: SmokeDetectorIcon,
  B: BuzzerIcon,
  W: WifiIcon,
  R: EthernetIcon,
  Z: FrameButtonIcon,
  L: FrameLedIcon
};

export const snapInsMap = {
  'HN1-W-S-00/PW': Switch,
  'HN1-W-T-00/PW': DoubleSwitch,
  'HN1-CW-4-00/PW': Relay,
  'HN1-W-1-00/PW': Power,
  'HN2-W-11-00/PW': PowerPower,
  'HN2-W-S1-00/PW': SwitchPower,
  'HN2-W-1S-00/PW': PowerSwitch,
  'HN2-W-T1-00/PW': DoubleSwitchPower,
  'HN2-W-1T-00/PW': PowerDoubleSwitch,
  'HN2-W-TS-00/PW': DoubleSwitchSwitch,
  'HN3-W-W11-00/PW': WifiPowerPower,
  'HN2-W-R1-00/PW': RJPower,
  'HN3-W-R11-00/PW': RJPowerPower,
  'HN1-CW-B-00/PW': Buzzer,
  'HN1-C-D-00/PW': Smoke,
  'HN1-W-P-00/PW': Unknown,
  'HN1-Q-00/PW': Unknown,
  'HN1-C-H-00/PW': Temperature,
  'HN1-W-J-00/PW': Temperature,
  'HN1-W-X-00/PW': Switch,
  'HN1-6-00/PW': Unknown,
  'HN3-W-111-00/PW': PowerPowerPower,
  'HN3-W-SSS-00/PW': SwitchSwitchSwitch,
  'HN2-W-SS-00/PW': SwitchSwitch,
  'HN3-W-TB1-00/PW': DoubleSwitchBuzzerPower,
  'HN3-W-TT1-00/PW': DoubleSwitchDoubleSwitchPower,
  'HN3-W-S1B-00/PW': SwitchPowerBuzzer,
  'HN4-W-TT1B-00/PW': DoubleSwitchDoubleSwitchPowerBuzzer,
  'HN1-C-DH-00/PW': Smoke,
  'HN1-C-DW-00/PW': SmokeWifi,
  'HN3-C-DW4-00/PW': SmokeWifiRelay
};

export const getSnapInIcon = (snapInCode: string): React.FC<SvgProps> => {
  return snapInsMap[snapInCode] || Unknown;
};

export const getDeviceIcon = (deviceSymbol: string): React.FC<SvgProps> => {
  return devicesMap[deviceSymbol];
};

export const buzzerMelodiesSelectOptions = Object.values(buzzerMelodies).map(
  (melody, index) => ({
    label: melody.name,
    value: index.toString()
  })
);

export const isTriggerAction = actionName =>
  deviceActions.find(action => action.key === actionName).trigger;

export const getDeviceIconBySymbol = deviceSymbol => {
  const device = Object.values(devices).find(
    deviceToCheck => deviceToCheck.symbol === deviceSymbol
  );

  return device ? device.icon : 'devices-icons/relay';
};

const parseSingleDevice = (deviceSymbol, deviceTypes) => {
  const devicesToReturn = [];

  if (deviceSymbol === devices.doubleSwitch.symbol) {
    const symbol = deviceTypes.find(
      type => type.symbol === devices.pulseSwitch.symbol
    );
    devicesToReturn.push({ id: getRandomKey().toString(), ...symbol });
    devicesToReturn.push({ id: getRandomKey().toString(), ...symbol });
  } else {
    const symbol = deviceTypes.find(type => type.symbol === deviceSymbol);
    devicesToReturn.push({ id: getRandomKey().toString(), ...symbol });
  }

  return devicesToReturn;
};

export const parseDockDevices = (dock, deviceTypes) => {
  const dockTypeRegexp = /...-..?-(.*?)-..\/../gm;
  const dockType = dockTypeRegexp.exec(dock.snapInCode)[1].split('');
  // add frame button and frame led as a first two devices for every dock
  const devicesToReturn = [
    ...parseSingleDevice(devices.frameButton.symbol, deviceTypes),
    ...parseSingleDevice(devices.frameLed.symbol, deviceTypes)
  ];

  dockType.forEach(deviceSymbol => {
    devicesToReturn.push(...parseSingleDevice(deviceSymbol, deviceTypes));
  });

  return devicesToReturn;
};

export const getDeviceInSnapInPlacement = (
  snapInCode: string,
  index: number
) => {
  const dockTypeRegexp = /...-..?-(.*?)-..\/../gm;
  const dockType = dockTypeRegexp.exec(snapInCode)[1].split('');
  const doubleSwitchesIndexes = [];
  const snapInDevicesPerHoles = {
    0: 0,
    1: 0,
    2: 0,
    3: 0
  };

  dockType.forEach((deviceSymbol, deviceSymbolIndex) => {
    // double switch on first hole
    if (
      deviceSymbolIndex === 0 &&
      deviceSymbol === devices.doubleSwitch.symbol
    ) {
      // starts from indexes 2 and 3 cause on 0 and 1 are frame button and frame led
      doubleSwitchesIndexes.push(...[2, 3]);
      snapInDevicesPerHoles[0] = 2;
      // double switch on hole grater than first
    } else if (deviceSymbol === devices.doubleSwitch.symbol) {
      const lastDoubleSwitchIndex =
        doubleSwitchesIndexes[doubleSwitchesIndexes.length - 1];
      const firstHalfDoubleSwitchToAddIndex = Number.isInteger(
        lastDoubleSwitchIndex
      )
        ? lastDoubleSwitchIndex + 1
        : deviceSymbolIndex + 2;
      const secondHalfDoubleSwitchToAddIndex =
        firstHalfDoubleSwitchToAddIndex + 1;

      doubleSwitchesIndexes.push(firstHalfDoubleSwitchToAddIndex);
      doubleSwitchesIndexes.push(secondHalfDoubleSwitchToAddIndex);
      snapInDevicesPerHoles[deviceSymbolIndex] = 2;
      // single device which took whole hole in snap in or fourth device which is always buzzer build in into the frame
    } else {
      snapInDevicesPerHoles[deviceSymbolIndex] = 1;
    }
  });

  const snapInHoleNumber = Object.keys(snapInDevicesPerHoles).reduce(
    (prev, holeIndex) => {
      if (prev.index !== null) {
        return prev;
      }

      return snapInDevicesPerHoles[holeIndex] + prev.sum > index - 2
        ? {
            index: holeIndex,
            sum: prev.sum
          }
        : {
            sum: snapInDevicesPerHoles[holeIndex] + prev.sum,
            index: null
          };
    },
    {
      sum: 0,
      index: null
    }
  );
  // eslint-disable-next-line no-nested-ternary
  const doubleDeviceSide = doubleSwitchesIndexes.includes(index)
    ? doubleSwitchesIndexes.findIndex(idx => idx === index) % 2 === 0
      ? 'left'
      : 'right'
    : '';

  return {
    doubleDeviceSide,
    snapInHoleNumber: snapInHoleNumber.index,
    deviceShape: roundDevicesSymbols.includes(dockType[index - 2])
      ? 'round'
      : 'rect'
  };
};
export const composeDeviceConnectionId = (
  deviceIndex: number,
  dockNumber,
  configDirection
) => `${configDirection}_${dockNumber}_${deviceIndex}`;

export const getDeviceTypesFromActions = (actions, docksPerRoom) => {
  const docks: any = (Object.values(docksPerRoom) as any[]).flat();

  if (actions.length === 0 || docks.length === 0) {
    return [];
  }

  return actions.map(
    ({ deviceNumber, dockNumber }) =>
      docks
        .find(dock => dock.number === dockNumber)
        .devices.find((_device, index) => index === deviceNumber).symbol
  );
};

export const isOutputDevice = device => Object.keys(device.actions).length > 0;

export const ledBrightnessPercentConvert = (
  brightness: number,
  isInPercent: boolean = false
): number => {
  const brightnessConverter = 2.54;

  if (isInPercent) {
    return Math.round(brightness * brightnessConverter);
  }
  return Math.round(brightness / brightnessConverter);
};

export default {
  parseDockDevices,
  getDeviceInSnapInPlacement,
  getDeviceIconBySymbol,
  snapInsMap,
  roundDevicesSymbols,
  deviceActions,
  buzzerMelodies,
  scenesLedColors,
  PressProfiles,
  devices,
  devicesConnectionsLedColors,
  composeDeviceConnectionId,
  buzzerMelodiesSelectOptions,
  getDeviceTypesFromActions,
  isOutputDevice,
  ledBrightnessPercentConvert
};
